module.exports = __webpack_public_path__ + "static/gather-demo-b12f1449decc289ba4fe534341885e59.png";